import { useAuth } from "lib/features/auth";
import { useStartUserSession } from "lib/features/users";
import { AnalyticsEvent } from "lib/types";

import { useHubSpot } from "./useHubSpot";

export const useUserSession = (): void => {
  const { authUser, requiresEmailVerification } = useAuth();
  const { trackHubSpotEvent } = useHubSpot();

  const enableStartUserSession =
    !!authUser && !authUser.is_ephemeral && !requiresEmailVerification;

  useStartUserSession({
    onSuccess: ({ is_first_user_session }) => {
      if (is_first_user_session) {
        trackHubSpotEvent(AnalyticsEvent.HubSpot_FirstLogin);
      }
    },
    enabled: enableStartUserSession,
  });
};
